<template>
  <div>
    <!--管理栏目-->
    <Modal title="管理栏目" width="520px" :mask-closable="false" v-model="visible">
      <span class="tips">按住排序按钮拖拽可对分类进行排序</span>
      <!-- 表格 -->
      <div class="table-box">
        <loading :isShow="listLoading" />
        <table width="100%" v-if="typeList && typeList.length > 0">
          <thead>
            <tr>
              <th>栏目名称</th>
              <th style="width: 160px">操作</th>
            </tr>
          </thead>
          <draggable v-model="typeList" tag="tbody" @update="update" filter=".undraggable">
            <tr v-for="item in typeList" :key="item.id + Date.now()" :class="{ activeTr: item.active }">
              <td class="undraggable">{{ item.name }}</td>
              <td style="width: 160px">
                <div class="action">
                  <div class="actionBlank undraggable"></div>
                  <div class="actionBtns">
                    <img class="table-btn undraggable" src="@static/images/product/edit_2.png" @click="$refs.categorizeFormModal.open(item)" />
                    <img class="table-btn undraggable" src="@static/images/product/delete.png" @click="removeTab(item.id)" />
                    <img class="table-btn" src="@static/images/product/drage.png" alt="" />
                  </div>
                </div>
              </td>
            </tr>
          </draggable>
        </table>
        <no-data v-if="!typeList.length && !listLoading"></no-data>
      </div>
    </Modal>
    <!-- 新增、编辑分类 -->
    <categorize-form-modal ref="categorizeFormModal" @reload="$emit('reload')" />
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>
<script>
import { common } from '@/api/mixins';
import draggable from 'vuedraggable';
import categorizeFormModal from './categorizeFormModal';
import confirmModal from '@/components/commons/confirmModal';
export default {
  mixins: [common],
  props: {},
  data: () => ({
    typeList: [],
    visible: false,
    listLoading: false,
    topItem: {},
    title: ''
  }),
  components: {
    confirmModal,
    categorizeFormModal,
    draggable
  },
  created() {},
  methods: {
    open(typeList) {
      typeList = JSON.parse(JSON.stringify(typeList));
      this.topItem = typeList[0];
      this.typeList = typeList.splice(1);
      this.listLoading = false;
      this.visible = true;
    },
    // 删除分类
    removeTab(id) {
      const data = this.typeList.find(item => item.id == id);
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: `是否要删除此栏目：${data.name}，删除后此栏目下的配置将会被清空`
        })
        .then(() => {
          this.listLoading = true;
          this.$http({
            url: '/buz/exhibitionPicConfigType/deleteCardType',
            type: 'GET',
            data: {
              id: id
            }
          }).then(res => {
            this.$emit('reload', id);
          }).finally(() => {
            this.listLoading = false;
          });
        })
        .catch(e => {});
    },
    // 排序
    update() {
      this.listLoading = true;
      let list = JSON.parse(JSON.stringify(this.typeList));
      list = list.map(item => item.id);
      this.$http({
        url: '/buz/exhibitionPicConfigType/sortCardType',
        type: 'POST',
        data: list
      })
        .then(res => {
          this.$emit('reload');
          this.$notice.msg('排序成功');
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
  }
};
</script>
<style lang='scss' scoped>
.tips {
  display: block;
  margin-bottom: 15px;
  color: #727c8e;
  background: #fff8ef;
  width: 100%;
  height: 80px;
  padding: 20px;
}
table {
  word-wrap: bread-word;
  word-break: break-all;
  table-layout: fixed;
  border-collapse: collapse;

  thead {
    background: #f8f8f9;
  }

  th {
    border: 1px solid #eee;
    padding: 10px 10px;
  }

  tr {
    &.activeTr {
      background: #409eff;
      color: #fff;

      .details {
        > div {
          color: #fff;
        }
      }
    }
  }

  td {
    text-align: center;
    border: 1px solid #eee;
    padding: 0 10px;
    height: 38px;
  }
}
.table-btn {
  margin: 0;
  padding: 0 15px;
  cursor: pointer;
}
.table-btn:not(:last-child) {
  border-right: 1px solid #ced1d5;
}
</style>